module.exports = __webpack_public_path__ + "img/svg - only background.fe200498.svg";